//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { changPassword } from '@/api/api';
export default {
  name: "PasswordModal",
  data: function data() {
    return {
      visible: false,
      confirmLoading: false,
      confirmDirty: false,
      validatorRules: {
        password: {
          rules: [{
            required: true,
            pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/,
            message: '密码由8位数字、大小写字母和特殊符号组成!'
          }, {
            validator: this.validateToNextPassword
          }]
        },
        confirmpassword: {
          rules: [{
            required: true,
            message: '请重新输入登陆密码!'
          }, {
            validator: this.compareToFirstPassword
          }]
        }
      },
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      form: this.$form.createForm(this)
    };
  },
  created: function created() {
    console.log("created");
  },
  methods: {
    show: function show(username) {
      var _this = this;

      this.form.resetFields();
      this.visible = true;
      this.model.username = username;
      this.$nextTick(function () {
        _this.form.setFieldsValue({
          username: username
        });
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      // 触发表单验证
      this.form.validateFields(function (err, values) {
        if (!err) {
          _this2.confirmLoading = true;
          var formData = Object.assign(_this2.model, values);
          changPassword(formData).then(function (res) {
            if (res.success) {
              _this2.$notification.success({
                message: res.message
              });

              _this2.$emit('ok');
            } else {
              _this2.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            _this2.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    validateToNextPassword: function validateToNextPassword(rule, value, callback) {
      var form = this.form;
      var confirmpassword = form.getFieldValue('confirmpassword');
      console.log("confirmpassword==>", confirmpassword);

      if (value && confirmpassword && value !== confirmpassword) {
        callback('两次输入的密码不一样！');
      }

      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], {
          force: true
        });
      }

      callback();
    },
    compareToFirstPassword: function compareToFirstPassword(rule, value, callback) {
      var form = this.form;

      if (value && value !== form.getFieldValue('password')) {
        callback('两次输入的密码不一样！');
      } else {
        callback();
      }
    },
    handleConfirmBlur: function handleConfirmBlur(e) {
      var value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    }
  }
};